<template>
	<b-table-simple hover striped small responsive table-class="mb-0">
		<b-tbody>
			<b-tr>
				<b-th scope="col" class="input-column-md"></b-th>
				<b-th scope="col" class="input-column-xs">Total</b-th>
				<b-th scope="col" class="input-column-xs">Ranks</b-th>
				<b-th scope="col" class="input-column-sm">Ability</b-th>
				<b-th scope="col" class="input-column-xs">Class</b-th>
				<b-th scope="col" class="input-column-xs">Insight</b-th>
				<b-th scope="col" class="input-column-xs">Race</b-th>
				<b-th scope="col" class="input-column-xs">Theme</b-th>
				<b-th scope="col" class="input-column-xs">Misc</b-th>
			</b-tr>
			<slot></slot>
		</b-tbody>
		<b-tfoot>
			<b-tr>
				<b-th colspan="9">* Armor Check Penalty applied</b-th>
			</b-tr>
		</b-tfoot>
	</b-table-simple>
</template>

<script>
export default {
	
}
</script>

<style scoped>
.input-column-md {
	min-width: 12em;
}
.input-column-sm {
	min-width: 8em;
}
.input-column-xs {
	min-width: 4em;
}
</style>